import {isNonEmptyString, isNullOrUndefined} from "../services/Validator";
import {useState} from "react";
import {log_user} from "../api/authentication";
import {setLocalItemFromKey, kTokenKey, kRefreshTokenKey} from "../services/LocalStorage";
import {useNavigate} from "react-router";
import {useDispatch} from "react-redux";
import {updateUserEmail} from "../actions/user";
import {kFakeToken} from "../services/Faker";
import {internalRoutes} from "../constants/internalRoutes";
import {useLocation} from "react-router-dom";
import AuthenticationTopBar from "../components/bars/authenticationScreen/AuthenticationTopBar";
import AuthenticationContentLayout from "../components/layouts/authenticationScreen/AuthenticationContentLayout";
import AuthenticationCard from "../components/cards/authenticationScreen/AuthenticationCard";

export default function AuthenticationScreen() {
    // Used in index.js to authenticate user for
    // dashboard access

    // PROPERTIES
    // ---- Navigation
    const location = useLocation()
    const navigate = useNavigate();
    // ---- Store
    const dispatch = useDispatch();
    // ---- UX
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    // ---- Functional
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isPasswordVisible, setIsPasswordVisible] = useState(false)

    // BUILD
    return (
        <div className={"bg-backgroundLight1 w-full h-[100svh] flex flex-col justify-start items-center"}>
            <AuthenticationTopBar />
            <AuthenticationContentLayout>
                <AuthenticationCard error={error}
                                    email={email}
                                    onEmailChanged={onEmailChanged}
                                    password={password}
                                    isPasswordVisible={isPasswordVisible}
                                    setIsPasswordVisible={setIsPasswordVisible}
                                    onPasswordChanged={onPasswordChanged}
                                    isLoading={isLoading}
                                    logUser={logUser} />
            </AuthenticationContentLayout>
        </div>
    );

    // METHODS
    // ---- Log with provided credentials
    function logUser() {
        // Prepare
        const navigateAfterSuccess = () => {
            // ---- Navigate to PageViewScreen
            const redirectPath = new URLSearchParams(location.search).get('redirect')
            if (redirectPath && redirectPath !== internalRoutes.authentication) {
                navigate(redirectPath, { replace: true })
            } else {
                navigate(internalRoutes.home) // fallback par défaut
            }
        }

        // Perform
        if (process.env.REACT_APP_FAKER === "true") {
            // Case : App run with FAKER mode
            // ---- Set environment variables
            setLocalItemFromKey(kTokenKey, kFakeToken.token)
            setLocalItemFromKey(kRefreshTokenKey, kFakeToken.refreshToken)
            dispatch(updateUserEmail(kFakeToken.user))
            // ---- Navigate to PageViewScreen
            navigateAfterSuccess()
        } else {
            // Defensive measure
            if (!isNonEmptyString(email) || !isNonEmptyString(password))
                return
            // Prepare
            setIsLoading(true)
            setError(null)
            let data = {
                "username": email,
                "password": password
            }
            // Execute
            log_user(data).then((res) => {
                if (isNonEmptyString(res?.token) && isNonEmptyString(res.refreshToken) && isNonEmptyString(res?.user)) {
                    // ---- Store tokens in local storage and user email
                    setLocalItemFromKey(kTokenKey, res.token)
                    setLocalItemFromKey(kRefreshTokenKey, res.refreshToken)
                    dispatch(updateUserEmail(res.user))
                    // ---- Navigate to PageViewScreen
                    navigateAfterSuccess()
                } else {
                    setError("Une erreur est survenue et rend impossible la connexion")
                }
            }).catch((err) => {
                if (err?.message) {
                    setError(err?.message)
                }
                setError('Une erreur est survenue et rend impossible la connexion')
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }

    // ---- On email changed
    function onEmailChanged(value) {
        if (isNullOrUndefined(value))
            return
        setEmail(value.trim())
    }

    // ---- On password changed
    function onPasswordChanged(value) {
        if (isNullOrUndefined(value))
            return
        setPassword(value.trim())
    }
}